var angular = require('angular');
var ngModule = angular.module('/winners/views/winners.html', []);
ngModule.run(['$templateCache', function($templateCache) {
  $templateCache.put('/winners/views/winners.html',
    '<section class="panel panel-winners">\n' +
    '    <header class="panel-heading clearfix">\n' +
    '        <button ng-click="clear()" class="btn btn-danger pull-right">{{ \'CLEAR_ALL\' | translate }}</button>\n' +
    '    </header>\n' +
    '</section>\n' +
    '<div class="list-group participants">\n' +
    '    <div class="list-group-item participant" ng-repeat="w in winners track by $index">\n' +
    '        <strong class="participant__spoke winner__spoke">{{ :: $index  + 1}}</strong>\n' +
    '        <span class="participant__name">{{ :: w.name }}</span>\n' +
    '    </div>\n' +
    '    <div class="list-group-item list-group-item-info" ng-if="!winners.length">{{ \'PAGES.WINNERS.EMPTY\' | translate }}</div>\n' +
    '</div>\n' +
    '');
}]);

module.exports = "/winners/views/winners.html";